import { makeAutoObservable, runInAction, toJS } from 'mobx'
import { http } from '@/utils'

class SystemStore {

    //数据列表初始化
    dataList = [];

    //总条数
    total = '';

    //条数
    pagesize = 10;

    //当前页
    page = 1;

    //用户id
    jrxtid=JSON.parse(window.localStorage.getItem('jrxtid'))||''

    //表单收集
    valueData = {}

    //弹框状态初始化
    isActive = false

    //弹框名字
    title = ''

    //查询字段
    xtmc=''

    //批量删除
    moreId=''
    constructor() {
        makeAutoObservable(this)
    }
    //数据获取
    getDataList = async () => {
        const res = await http.get(`/adminapi/systemmanagement?page=${this.page}&pagesize=${this.pagesize}&jrxtid=${this.jrxtid}&xtmc=${this.xtmc}`)
        if (res.data.code === 200) {
            runInAction(() => {
                this.dataList = JSON.parse(JSON.stringify(res.data.data.data.data))
                this.total = res.data.data.data.total
            })
        }
    }

    //删除
    getDeleteButtom = async (id) => {
        const res = await http.delete(`/adminapi/systemmanagement/${id}`)
        if (res.status) {
            this.getDataList()
        }
    }

    //添加
    getAddButtom = async (values) => {
        const res = await http.post(`/adminapi/systemmanagement`, values)
        if (res.status === 200) {
            this.getDataList()
        }
    }

    //修改
    getPutInformation = async (values) => {
        const res = await http.put(`/adminapi/systemmanagement/${this.valueData.id}`, values)
        if (res.status === 200) {
            this.getDataList()
        }
    }
}

export { SystemStore }